export default __webpack_public_path__ + "static/carbon-free-neutralizacao-62980bf72f5f1e6667933bda39f6637b.jpg";